import React from "react";
import styled from "styled-components";
// Shared with the videoCards content block (ContentRenderer) — one card, one place.
import VideoCard from "../../../components/molecules/VideoCard/VideoCard";
import { VideoMeta } from "../../../services/video.service";

type Props = {
  videos: VideoMeta[];
  loading: boolean;
  loadingMore: boolean;
  hoverId: string | null;
  onHoverChange: (id: string | null) => void;
  lastVideoRef: (node: HTMLDivElement | null) => void;
  onVideoClick: (videoUid: string) => void;
  onToggleSaved?: () => void;
  savedOnly: boolean;
};

const VideoGrid: React.FC<Props> = ({
  videos,
  loading,
  loadingMore,
  hoverId,
  onHoverChange,
  lastVideoRef,
  onVideoClick,
  onToggleSaved,
  savedOnly,
}) => {
  return (
    <Grid>
      {videos.map((video, index) => (
        <VideoCard
          key={video.uid}
          video={video}
          isHover={hoverId === video.uid}
          ref={index === videos.length - 1 ? lastVideoRef : undefined}
          onHoverStart={() => onHoverChange(video.uid)}
          onHoverEnd={() => {
            if (hoverId === video.uid) onHoverChange(null);
          }}
          onClick={() => onVideoClick(video.uid)}
          onToggleSaved={onToggleSaved}
          savedOnly={savedOnly}
        />
      ))}

      {loading && <Loading>Chargement…</Loading>}

      {!loading && videos.length === 0 && (
        <EmptyState>Aucune vidéo ne correspond à ces filtres.</EmptyState>
      )}

      {!loading && loadingMore && <Loading>Chargement…</Loading>}
    </Grid>
  );
};

export default VideoGrid;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  margin: 0;
  padding: 8px 20px;
  /* Transparent: the cards sit on the page tint (DisplayVideos). */
  background: transparent;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 220px));
    justify-content: center;
    gap: 16px;
    padding: 16px;
  }
`;

const Loading = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 24px 0;
  font-size: 1.2em;
  color: #555;
`;

const EmptyState = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 32px 0;
  color: #777;
`;